/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".top-part[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center}.config-btn[_ngcontent-%COMP%]{margin:0 10px;border:none;padding:4px;border-radius:6px;cursor:pointer}.head-wrap[_ngcontent-%COMP%]{background-size:cover;padding:3% 0;max-height:168px}\n/*# sourceMappingURL=main-content.component.css.map*/"];
export { styles as styles };
